import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const QuizPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        window.location.href = 'https://forms.gle/jGeJTKqFWgs7dDZH8';
    }, [navigate]);

    return null;
};

export default QuizPage;